export default {
  relatedTitle: 'Ilustraciones Relacionadas, Iconos y dibujos',
};
